


































































import {
  defineComponent
} from '@nuxtjs/composition-api';
import CategoryGridItem from "~/components/Palmers/Category/CategoryGridItem.vue";
import CategoryGridItemMobile from "~/components/Palmers/Category/CategoryGridItemMobile.vue";
import Slider from "~/components/Palmers/BaseComponents/Slider/Slider.vue";
import SliderItem from "~/components/Palmers/BaseComponents/Slider/SliderItem.vue";
import PictureItem from "~/components/Palmers/BaseComponents/Picture/PictureItem.vue";
import {useUrl} from "~/composables/Palmers";
export default defineComponent({
  name: 'CategoryGrid',
  props: {
    categories: {
      type: [Array, String],
      require: true
    },
    caption: {
      type: Object,
      require: true
    },
    mobileTitle: {
      type: String
    },
  },
  components: {
    CategoryGridItem,
    CategoryGridItemMobile,
    Slider,
    SliderItem,
    PictureItem
  },
  setup() {
    const {getCategoryUrl} = useUrl();
    return {
      getCategoryUrl
    }
  }
});
